import React from "react";

import ContentCore from "../../../../core/workingContent";

const FinishPunctual = () => {
  return (
    <ContentCore />
  )
}

export default FinishPunctual